import { lddGlobalSessionInfo } from "../Components/navigationTypes";

const Storage = {
    viewPDF: (
        docName: string,
        folder: string,
        AppID: string,
        SESSION_INFO: lddGlobalSessionInfo,
    ) => {
        const { appProvinceShort, firm, sid } = SESSION_INFO;
        const RWAPI = `/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${appProvinceShort}/${firm.id}/${AppID}`
        try {
            fetch(`${RWAPI}/filedrive/storageDocGet?SessionID=${sid}&name=${encodeURIComponent(docName)}&path=${encodeURIComponent(folder)}`)
                .then(async (response) => {
                    if (response && response.ok) {
                        const data = await response.arrayBuffer();
                        const blob = new Blob([data], { type: 'application/pdf' });
                        const blobUrl = URL.createObjectURL(blob);
                        window.open(blobUrl, '_blank');
                    }
                })
        } catch (e) { }
    }
}

export default Storage;